import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
var _excluded = ["id", "title", "className", "bordered", "extra", "children", "footer"];
import React, { forwardRef } from 'react';
import ClassNames from "classnames";
var Panel = /*#__PURE__*/forwardRef(function (props, ref) {
  var id = props.id,
    title = props.title,
    className = props.className,
    _props$bordered = props.bordered,
    bordered = _props$bordered === void 0 ? true : _props$bordered,
    extra = props.extra,
    children = props.children,
    footer = props.footer,
    restPorps = _objectWithoutPropertiesLoose(props, _excluded);
  var classNames = ClassNames("ap-panel", className, {
    "ap-panel-bordered": bordered
  });
  var header = (title || extra) && /*#__PURE__*/React.createElement("div", {
    className: ClassNames('ap-panel-head', {
      'has-extra': extra
    })
  }, /*#__PURE__*/React.createElement("div", {
    className: "ap-panel-head-wrapper"
  }, /*#__PURE__*/React.createElement("div", {
    className: "ap-panel-head-title",
    "aria-label": title
  }, /*#__PURE__*/React.createElement("div", {
    className: "ap-panel-head-title-text"
  }, title))));
  return /*#__PURE__*/React.createElement("div", _extends({
    id: id,
    ref: ref,
    className: classNames
  }, restPorps), header, /*#__PURE__*/React.createElement("div", {
    className: "ap-panel-body"
  }, /*#__PURE__*/React.createElement("div", {
    className: "ap-panel-content"
  }, children), footer && /*#__PURE__*/React.createElement("div", {
    className: "ap-panel-footer"
  }, footer)), extra && /*#__PURE__*/React.createElement("div", {
    className: "ap-panel-extra"
  }, extra));
});
export default Panel;